<template>
  <div
    class="main-layout predicted-xlcs-page predicted-item-page"
    v-loading="isLoading"
  >
    <el-card class="box-inner box-bg">
      <c-title slot="header" title="入学测试"></c-title>
      <div class="pb110">
        <div class="div-scroll">
          <div class="form-container">
            <el-form
              ref="form"
              :model="handleData"
              label-position="top"
              v-if="this.titleData.length"
            >
              <el-form-item
                :label="index + 1 + '、' + item.name"
                v-for="(item, index) in titleData"
                :key="item.id"
              >
                <el-radio-group v-model="handleData[item.id]">
                  <el-radio
                    :label="option.optionId + ',' + option.score"
                    v-for="option in item.options"
                    :key="option.optionId"
                    >{{ option.optionName }}</el-radio
                  >
                </el-radio-group>
              </el-form-item>
              <el-form-item class="btn-item">
                <el-button type="primary" @click="onSubmit" :disabled="isSubmit">提交</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      handleData: {},
      titleData: [],
      resultData: [],
      isSubmit: false,
      isLoading: false,
      status: null,
    };
  },
  created() {
    this.SUCCESS_CODE = this.$store.state.dic.SUCCESS_CODE;
  },
  mounted() {
    // this.getMyInfo();
    // this.getTitleAndResult();
    this.getTitleData();
  },
  methods: {
    // 获取入学测试信息
    getMyInfo() {
      this.$http.get("/welcome-forecast/test/myInfo").then((res) => {
        if (res.code == this.SUCCESS_CODE) {
          //   this.applyInfo = res.data || {};
          this.status = res.data && res.data.status ? res.data.status : 0;
        }
      });
    },
    //查询入学测试题目
    getTitleData() {
      this.$http.get("/welcome-forecast/test/getRandomTitleList").then(res => {
        if(res.code == this.SUCCESS_CODE) {
          this.titleData = res.data || [];
        }
      })
    },
    //查询入学测试结果
    getMyTest() {
      return this.$http.get("/welcome-forecast/test/myTestResult");
    },
    getTitleAndResult() {
      this.isLoading = true;
      Promise.all([this.getTitleData(), this.getMyTest()])
        .then((values) => {
          let res1 = values[0];
          let res2 = values[1];
          if (
            res1.code == this.SUCCESS_CODE &&
            res2.code == this.SUCCESS_CODE
          ) {
            this.titleData = res1.data || [];
            this.resultData = res2.data || [];
            if (this.resultData.length) {
              this.resultData.forEach((item) => {
                // this.handleData[item.titleId] =
                //   item.optionId + "," + item.score;
                let value = item.optionId + "," + item.score;
                this.$set(this.handleData, item.titleId, value);
              });
              console.log(this.handleData);
            }
          }
          this.isLoading = false;
        })
        .catch((err) => {
          this.Loading = false;
        });
    },
    onSubmit() {
      
      let resultData = [];
      let titleIds = this.titleData.map((item) => item.id); // 题目id数组
      let titleIndexs = titleIds.map((item, index) => index + 1);
      // console.log(titleIds);
      // console.log(titleIndexs);
      let existIndexs = []; // 已存在的项
      // let noExistIndexs = []; // 不存在的项
      for (let key in this.handleData) {
        if (titleIds.indexOf(key) != -1) {
          existIndexs.push(titleIds.indexOf(key) + 1);
        }
        resultData.push({
          titleId: key,
          optionId: this.handleData[key].split(",")[0],
          score: this.handleData[key].split(",")[1],
        });
      }
      if (existIndexs.length < titleIndexs.length) {
        for (let i = 0; i < existIndexs.length; i++) {
          let index = titleIndexs.indexOf(existIndexs[i]);
          titleIndexs.splice(index, 1);
        }
        let indexStr = titleIndexs.join();
        this.$alert("请完成" + indexStr + "题后提交！", "提示", {
          type: "warning",
        }).then(() => {});
        return;
      }
      this.$confirm("请确认无误后提交?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = resultData;
          this.saveTest(params);
        })
        .catch(() => {});
    },
    saveTest(params) {
      this.isSubmit = true;
      this.isLoading = true;
      this.$http
        .post("/welcome-forecast/test/saveTest", params)
        .then((res) => {
          if (res.code == this.SUCCESS_CODE) {
            this.$message.success(res.msg);
            this.$router.go(-1);
            // this.getMyInfo();
          } else {
            this.$message.error(res.msg);
          }
          this.isLoading = false;
          this.isSubmit = false;
        })
        .catch((err) => {
          this.$message.error(err);
          this.isLoading = false;
          this.isSubmit = false;
        });
    },
    updateTest(params) {
      this.isLoading = true;
      this.$http
        .post("/welcome-forecast/test/updateTest", params)
        .then((res) => {
          if (res.code == this.SUCCESS_CODE) {
            this.$message.success(res.msg);
            this.getMyInfo();
          } else {
            this.$message.error(res.msg);
          }
          this.isLoading = false;
        })
        .catch((err) => {
          this.$message.error(err);
          this.isLoading = false;
        });
    },
  },
};
</script>

<style>
</style>
